module.exports = __webpack_public_path__ + "static/media/dpex-china.a1a92b26.svg";